// Calibrated so a one-row tile is never shorter than `support` or `vehicle-warehouse` at natural height.
export const DASHBOARD_ROW_UNIT = 'calc(var(--eag-space-step) * 74rem)';
